import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { useDeclination } from '@cp/shared/declination';

export const useAuthorAge = (age: number | undefined): string => {
  const declination = useDeclination();
  return age ? `${age} ${declination(Number(age), DeclinationMnemonic.Year)}` : '';
};
